import type { FieldValues } from "react-hook-form";
import type { StepConfig } from "./types";

type MultiStepSummaryProps<TFormData extends FieldValues = FieldValues> = {
	steps: StepConfig<TFormData>[];
	subtitle?: string;
};

export const MultiStepSummary = <TFormData extends FieldValues = FieldValues>({
	steps,
	subtitle = "Review the information below before submitting.",
}: MultiStepSummaryProps<TFormData>) => {
	const stepsWithSummary = steps.filter((step) => step.summaryComponent);

	return (
		<div className="flex flex-col space-y-[30px] pb-[120px]">
			<p className="text-[14px] text-secondary">{subtitle}</p>

			{stepsWithSummary.map((step) => {
				const SummaryComponent = step.summaryComponent!;
				return (
					<div key={step.name}>
						<SummaryComponent />
					</div>
				);
			})}
		</div>
	);
};
